import { render, staticRenderFns } from "./ReferenceHistoryDialog.vue?vue&type=template&id=06ad2d69"
import script from "./ReferenceHistoryDialog.vue?vue&type=script&lang=ts"
export * from "./ReferenceHistoryDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports